/* eslint-disable */
export const maxLifetime = 80

export default [
[0, 100000],
[1, 50000],
[2, 40000],
[3, 32000],
[4, 25600],
[5, 20480],
[6, 16384],
[7, 13107],
[8, 10486],
[9, 8389],
[10, 6711],
[11, 5369],
[12, 4295],
[13, 3436],
[14, 2749],
[15, 2199],
[16, 1759],
[17, 1407],
[18, 1126],
[19, 901],
[20, 721],
[21, 576],
[22, 461],
[23, 415],
[24, 374],
[25, 336],
[26, 303],
[27, 272],
[28, 245],
[29, 221],
[30, 199],
[31, 179],
[32, 161],
[33, 145],
[34, 130],
[35, 117],
[36, 106],
[37, 95],
[38, 85],
[39, 77],
[40, 69],
[41, 62],
[42, 56],
[43, 50],
[44, 45],
[45, 41],
[46, 37],
[47, 33],
[48, 30],
[49, 27],
[50, 24],
[51, 22],
[52, 20],
[53, 18],
[54, 16],
[55, 14],
[56, 13],
[57, 12],
[58, 10],
[59, 9],
[60, 8],
[61, 8],
[62, 7],
[63, 6],
[64, 6],
[65, 5],
[66, 4],
[67, 4],
[68, 4],
[69, 3],
[70, 3],
[71, 3],
[72, 2],
[73, 2],
[74, 2],
[75, 2],
[76, 2],
[77, 1],
[78, 1],
[79, 1],
[80, 1],
[81, 0]
]
